import { InputHTMLAttributes } from 'react';

export type UnitType = 'm' | 'ft';

export interface CalculatorState {
  unit: UnitType;
  numberOfRooms: number;
  roomWidth: number;
  maxRoomWidthInMeters: number;
  rentCostPerSquareUnit: number;
  fov: number;
  tableWidthInMeters: number;
}

export interface CalculatorResults {
  wastedSpace: string;
  monthlyCost: string;
  yearlyCost: string;
}

export interface FovImage {
  fov: number;
  id: string;
}

export interface VideoRoiCalculatorFieldProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value' | 'type'> {
  title: string;
  value: number;
  onChange: (value: number) => void;
  unitSuffix?: React.ReactNode;
}
